export const ANALYTICS_EVENTS = {
  pageview: '$pageview',
  exception: '$exception',
  webVitals: '$web_vitals',

  enrichClicked: 'enrich_clicked',
  meetingPrepAgentRun: 'meeting_prep_agent_run',
  meetingPrepClicked: 'meeting_prep_clicked',
  actionStatusClicked: 'action_status_clicked',
  actionFeedbackClicked: 'action_feedback_clicked',
  eventClassificationChanged: 'event_classification_changed',
  participantDetailsClicked: 'participant_details_clicked',

  deleteThesisClicked: 'delete_thesis_clicked',
  removeThesisMemberClicked: 'remove_thesis_member_clicked',
  createThesisClicked: 'create_thesis_clicked',
  editThesisClicked: 'edit_thesis_clicked',
  attachThesisMemberClicked: 'attach_thesis_member_clicked',
  thesisClicked: 'thesis_clicked',

  viewInteractionClicked: 'view_interaction_clicked',

  gmailSubscriptionButtonClicked: 'gmailsubscription_button_clicked',
  calendarSubscriptionButtonClicked: 'calendar_subscription_button_clicked',
  syncGmailHistoryButtonClicked: 'sync_gmail_history_button_clicked',
  syncCalendarHistoryButtonClicked: 'sync_calendar_history_button_clicked',
  syncCalendarEventLinkingButtonClicked:
    'sync_calendar_event_linking_button_clicked',

  granolaConnectButtonClicked: 'granola_connect_button_clicked',
  granolaDisconnectButtonClicked: 'granola_disconnect_button_clicked',
  syncGranolaNotesButtonClicked: 'sync_granola_notes_button_clicked',
  firefliesConnectButtonClicked: 'fireflies_connect_button_clicked',
  firefliesDisconnectButtonClicked: 'fireflies_disconnect_button_clicked',
  syncFirefliesNotesButtonClicked: 'sync_fireflies_notes_button_clicked',

  personInterestAdded: 'person_interest_added',
  personInterestRemoved: 'person_interest_removed',
  personSkillAdded: 'person_skill_added',
  personSkillRemoved: 'person_skill_removed',
  createPhoneClicked: 'create_phone_clicked',
  editCompanyClicked: 'edit_company_clicked',
  detachCompanyClicked: 'detach_company_clicked',
  attachCompanyClicked: 'attach_company_clicked',
  attachEmailClicked: 'attach_email_clicked',
  createEmailClicked: 'create_email_clicked',
  personDetailsClicked: 'person_details_clicked',

  companyIndustryAttached: 'company_industry_attached',
  companyHeadquartersSet: 'company_headquarters_set',
  companyLocationAttached: 'company_location_attached',
  attachPersonClicked: 'attach_person_clicked',
  editPersonRelationClicked: 'edit_person_relation_clicked',
  detachPersonClicked: 'detach_person_clicked',
  companiesDetailsClicked: 'companies_details_clicked',

  reactivateSubscriptionButtonClicked: 'reactivate_subscription_button_clicked',
  subscriptionButtonClicked: 'subscription_button_clicked',
  skipSubscriptionButtonClicked: 'skip_subscription_button_clicked',

  entityFeedbackClicked: 'entity_feedback_clicked',

  apiTokenRefreshFailed: 'api_token_refresh_failed',
  apiError: 'api_error',
  graphqlError: 'graphql_error',

  searchUsed: 'search_used',

  opportunityDetailsClicked: 'opportunity_details_clicked',
  opportunityStateUpdated: 'opportunity_state_updated',
  opportunityInfoUpdated: 'opportunity_info_updated',
  opportunityReassigned: 'opportunity_reassigned',
  opportunityDraftSentNow: 'opportunity_draft_sent_now',
  opportunityDraftSentLater: 'opportunity_draft_sent_later',
  opportunityDraftEdited: 'opportunity_draft_edited',
  opportunityDraftRegenerated: 'opportunity_draft_regenerated',
  opportunityBouncerReplayed: 'opportunity_bouncer_replayed',
  opportunityPitchDeckViewed: 'opportunity_pitch_deck_viewed',
  opportunitySourceThreadViewed: 'opportunity_source_thread_viewed',
  opportunityActiveThreadViewed: 'opportunity_active_thread_viewed',
  opportunityActiveThreadChanged: 'opportunity_active_thread_changed',
  opportunityThreadBrowsed: 'opportunity_thread_browsed',
  opportunityCreated: 'opportunity_created',
  opportunityClosed: 'opportunity_closed',
  opportunityActivityRecorded: 'opportunity_activity_recorded',
  opportunityDeckAdded: 'opportunity_deck_added',
  opportunityDeckRemoved: 'opportunity_deck_removed',
  opportunityMarkedInvested: 'opportunity_marked_invested',

  triageFinalDecision: 'triage_final_decision',

  missionDetailsClicked: 'mission_details_clicked',
  missionStatusUpdated: 'mission_status_updated',

  memberProfileUpdated: 'member_profile_updated',
  memberSettingsUpdated: 'member_settings_updated',
  agentTriageToggled: 'agent_triage_toggled',
  agentMissionsToggled: 'agent_missions_toggled',

  personalAccessTokenCreated: 'personal_access_token_created',
  personalAccessTokenRegenerated: 'personal_access_token_regenerated',
  personalAccessTokenRevoked: 'personal_access_token_revoked',
  personalAccessTokenUpdated: 'personal_access_token_updated',
} as const

// Only dynamic event name in the codebase — keeps the existing `reprocess_${jobName}_clicked` format.
export const reprocessJobClickedEvent = (jobName: string) =>
  `reprocess_${jobName}_clicked`
